/*
 * Trigger inherits typography from the host page (the shadow host's inline
 * style allows font to inherit through `all: initial`). Don't hard-code a
 * font-family here — that would override the host site's brand font.
 *
 * Colors come from the host's Scalebloom palette tokens with light-theme
 * fallbacks, aliased once on :host. See dialog.css for the full rationale.
 */

:host {
  --_base: var(--clr-base, hwb(0 97% 3%));
  --_contrast: var(--clr-contrast, hwb(0 11% 89%));
}

.trigger-floating {
  position: fixed;
  bottom: 1.25rem;
  right: 1.25rem;
  z-index: 2147483000;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  border-radius: 999px;
  background: var(--_contrast);
  color: var(--_base);
  border: none;
  cursor: pointer;
  font: inherit;
  font-size: 0.9375rem;
  font-weight: 500;
  box-shadow: 0 12px 28px -8px rgba(0, 0, 0, 0.35);
  transition: transform 0.15s ease-out;

  &:hover {
    transform: scale(1.05);
  }
  & svg {
    width: 1.125rem;
    height: 1.125rem;
  }
}

.trigger-inline {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 1rem;
  border-radius: 8px;
  background: transparent;
  color: var(--_contrast);
  border: 1px solid var(--_contrast);
  cursor: pointer;
  font: inherit;
  font-size: 0.9375rem;

  &:hover {
    background: var(--_contrast);
    color: var(--_base);
  }
  & svg {
    width: 1rem;
    height: 1rem;
  }
}
